module.exports = __webpack_public_path__ + "img/southernrock.d2cd9a7f.png";